import React from 'react'
import {Col, Row} from "antd";

import {WeaLocaleProvider,WeaInputNumber} from "ecCom";
const getLabel = WeaLocaleProvider.getLabel;

export default class SettingExtend extends React.Component{

    render (){
        const {setting,setSetting} = this.props
        const {showNumber} = setting
        return (
            <div>
                {/*<div style={{'margin-top':'10px'}}>*/}
                    {/*<Row>*/}
                        {/*<Col span={6} >*/}
                            {/*<div>{getLabel(19493, '显示条数')} :</div>*/}
                        {/*</Col>*/}
                        {/*<Col span={18}>*/}
                            {/*<WeaInputNumber  value={showNumber} viewAttr={2} onChange={value => setSetting({showNumber: value})}/>*/}
                        {/*</Col>*/}
                    {/*</Row>*/}
                {/*</div>*/}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4coms/menuPerfect/components/settingExtend.js